/*
 * トレカキングダム custom.js
 * 商品追加・数量ボタン・追加通知・カート内ポイント表示
 */

window.addEventListener('load', function() {
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.ProductItem__FormSubmit');
    if (!button) return;

    event.preventDefault();

    button.textContent = '追加中...';
    button.classList.add('add_item');
    button.disabled = true;

    const parentForm = button
      .closest('.ProductItem__Bottom')
      .querySelector('.ProductItem__Form');

    const idValue = parentForm
      .querySelector('input[name="id"]').value;

    const quantityValue = parentForm
      .querySelector('input[name="quantity"]').value;

    let formData = {
      items: [
        {
          id: idValue,
          quantity: quantityValue
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then(data => {
        document.dispatchEvent(
          new CustomEvent('product:added', {
            detail: {
              product: data
            }
          })
        );

        updateCartDrawer();
        return updateCartCount();
      })
      .then(() => {
        button.textContent = 'カートに入れる';
        button.classList.remove('add_item');
        button.disabled = false;
      })
      .catch(error => {
        console.error('Error:', error);
      });
  });
});

window.addEventListener('load', function() {
  const plusButtons = document.querySelectorAll('.quantity_plus');

  plusButtons.forEach(plusButton => {
    plusButton.addEventListener('click', function(event) {
      const parentForm2 = this
        .closest('.ProductItem__Bottom')
        .querySelector('.ProductItem__Form');

      let quantityValue = parentForm2
        .querySelector('input[name="quantity"]').value;

      quantityValue = parseInt(quantityValue) + 1;

      const totalStock = parseInt(
        parentForm2
          .querySelector('.product_block_Inventory')
          .querySelector('.totalStock')
          .innerText
      );

      if (quantityValue == totalStock) {
        plusButton.parentElement.innerHTML = `
          <div class="no_plus" disabled>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M9.1665 10.8333H4.1665V9.16663H9.1665V4.16663H10.8332V9.16663H15.8332V10.8333H10.8332V15.8333H9.1665V10.8333Z"
                fill="black"
              />
            </svg>
          </div>
        `;
      }
    });
  });
});

window.addEventListener('load', function() {
  const downButtons = document.querySelectorAll('.quantity_down');

  downButtons.forEach(downButton => {
    downButton.addEventListener('click', function(event) {
      const parentForm3 = this
        .closest('.ProductItem__Bottom')
        .querySelector('.ProductItem__Form');

      let quantityValue2 = parentForm3
        .querySelector('input[name="quantity"]').value;

      const plusButton = parentForm3
        .querySelector('.quantity-wrapper_product-block_wrapper')
        .querySelector('.quantity-wrapper_product-block')
        .querySelector('.quantity_plus');

      quantityValue2 = parseInt(quantityValue2) - 1;

      const totalStock = parseInt(
        parentForm3
          .querySelector('.product_block_Inventory')
          .querySelector('.totalStock')
          .innerText
      );

      if (quantityValue2 < totalStock) {
        plusButton.parentElement.innerHTML = `
          <a
            href="#"
            class="quantity_plus"
            data-quantity="up"
            aria-label="{{ 'cart.items.increase_quantity' | t }}"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M9.1665 10.8333H4.1665V9.16663H9.1665V4.16663H10.8332V9.16663H15.8332V10.8333H10.8332V15.8333H9.1665V10.8333Z"
                fill="black"
              />
            </svg>
          </a>
        `;
      }
    });
  });
});

async function updateCartDrawer() {
  const res = await fetch('/?section_id=cart-drawer');
  const text = await res.text();

  const html = document.createElement('div');
  html.innerHTML = text;

  const newBox = html
    .querySelector('.section-cart-drawer')
    .innerHTML;

  document.querySelector('.section-cart-drawer').innerHTML = newBox;

  const cartIsEnpty = document.querySelector('#cart_is_empty');

  if (cartIsEnpty != null) {
    cartIsEnpty.textContent = 'カートは空です';
  }

  const startShippingButton = document.querySelector(
    '#start_shopping_button'
  );

  if (startShippingButton != null) {
    startShippingButton.textContent = '商品を探す';
  }

  const youMayLikeText = document.querySelector(
    '#cart_drawer_you_may_like'
  );

  if (youMayLikeText != null) {
    youMayLikeText.textContent = 'あなたにおすすめの商品';
  }
}

async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    document.querySelector('#cart_link__count').innerHTML =
      `<span class="cart-link__count">${cart.item_count}</span>`;
  } catch (error) {
    console.error('Error:', error);
  }
}

/*
 * 商品一覧から追加した場合にも、追加通知を表示
 */
;(() => {
  if (window.tckCartNoticeBridge) return;
  window.tckCartNoticeBridge = true;

  document.addEventListener('product:added', event => {
    const result = event.detail?.product;

    if (
      !result ||
      result.status >= 400 ||
      result.errors ||
      !Array.isArray(result.items) ||
      result.items.length === 0
    ) {
      return;
    }

    const template = document.getElementById('AddedNotification');

    if (!template?.content?.firstElementChild) return;

    const notice = template.content.firstElementChild.cloneNode(true);

    notice.dataset.productTitle = result.items
      .map(item => item.product_title || item.title || '商品')
      .join('、');

    const container =
      document.querySelector('.pageheader--sticky') || document.body;

    container.appendChild(notice);
  });
})();

/*
 * カートドロワーに獲得予定ポイント合計を表示
 * 各商品のポイントも、商品ID・数量ごとに補正
 */
;(() => {
  if (window.tckCartPointsInstalled) return;
  window.tckCartPointsInstalled = true;

  const drawerSelector = '.section-cart-drawer';
  const rowSelector = '[data-tck-cart-points]';
  const cartUrl = `${window.Shopify?.routes?.root || '/'}cart`;

  let revision = 0;
  let timer;
  let controller;
  let observer;

  function prepareRow() {
    const drawer = document.querySelector(drawerSelector);
    const footer = drawer?.querySelector('.cart-drawer__footer');

    if (!footer) return null;

    let row = footer.querySelector(rowSelector);

    if (!drawer.querySelector('.cart-item-list__body .cart-item')) {
      row?.remove();
      return null;
    }

    if (!row) {
      row = document.createElement('div');
      row.setAttribute('data-tck-cart-points', '');
      row.setAttribute('aria-live', 'polite');
      row.setAttribute('aria-atomic', 'true');

      row.style.cssText = `
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 6px 12px;
        margin: 12px 0;
        padding: 12px 14px;
        background: #edf7ef;
        color: #246b43;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 700;
      `;

      const label = document.createElement('span');
      label.textContent = '獲得予定ポイント合計';

      const value = document.createElement('span');
      value.setAttribute('data-tck-points-value', '');
      value.style.whiteSpace = 'nowrap';

      row.append(label, value);

      footer.insertBefore(
        row,
        footer.querySelector('.checkout-buttons')
      );
    }

    return row;
  }

  function schedule() {
    revision += 1;
    controller?.abort();
    clearTimeout(timer);

    const row = prepareRow();
    if (!row) return;

    row.setAttribute('aria-busy', 'true');

    row.querySelector('[data-tck-points-value]').textContent =
      '確認中…';

    timer = setTimeout(() => refresh(row, revision), 150);
  }

  async function refresh(row, requestedRevision) {
    const request = new AbortController();
    controller = request;

    const timeout = setTimeout(
      () => request.abort(),
      10000
    );

    const value = row.querySelector('[data-tck-points-value]');

    const isCurrent = () =>
      requestedRevision === revision && row.isConnected;

    try {
      const response = await fetch(`${cartUrl}?view=points`, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: request.signal,
      });

      if (!response.ok) {
        throw new Error('Points response unavailable');
      }

      const html = await response.text();
      if (!isCurrent()) return;

      const parsed = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const cart = parsed.querySelector('[data-loyal-cart]');

      const source = parsed.querySelector(
        '[data-loyal-snippet="epi_cart_total_points"] ' +
        '[data-loyal-target="total-points-value"]'
      );

      if (!cart || !source) {
        throw new Error('Points markup unavailable');
      }

      if (Number(cart.dataset.cartItemCount) === 0) {
        row.remove();
        return;
      }

      // 各商品のポイントを、商品ID・数量ごとに補正します。
      const pointSelector = '[data-loyal-target="point-value"]';

      const itemSources = Array.from(
        parsed.querySelectorAll(
          `[data-loyal-snippet="epi_product_points"] ${pointSelector}`
        )
      );

      const usedSources = new Set();

      row.closest(drawerSelector)
        ?.querySelectorAll(`.cart-item ${pointSelector}`)
        .forEach(target => {
          const itemSource = itemSources.find(item =>
            !usedSources.has(item) &&
            item.dataset.loyalItemId === target.dataset.loyalItemId &&
            (item.dataset.loyalQuantity || '1') ===
              (target.dataset.loyalQuantity || '1')
          );

          if (!itemSource) return;
          usedSources.add(itemSource);

          try {
            window.easyPointsSDK?.insertPointValue?.(itemSource);
          } catch (_) {
            // SDK が未準備の場合はサーバー側の表示値を使用します。
          }

          if (target.outerHTML !== itemSource.outerHTML) {
            target.replaceWith(itemSource.cloneNode(true));
          }
        });

      // 合計ポイントの端数処理・ボーナス等は easyPoints に任せます。
      try {
        window.easyPointsSDK?.insertPointValue?.(source);
      } catch (_) {
        // SDK が未準備の場合はサーバー側の表示値を使用します。
      }

      const points = source.querySelector(
        '[data-loyal-target="point-value-location"]'
      )?.textContent.trim();

      if (
        !points ||
        !/^[0-9][0-9,.\s\u00a0\u202f]*$/.test(points)
      ) {
        throw new Error('Points value unavailable');
      }

      value.textContent = `${points} pt`;

    } catch (_) {
      if (!isCurrent()) return;

      const link = document.createElement('a');
      link.href = cartUrl;
      link.textContent = 'カートページで確認';
      link.style.cssText =
        'color:inherit;text-decoration:underline;';

      value.replaceChildren(link);

    } finally {
      clearTimeout(timeout);

      if (controller === request) {
        controller = null;
      }

      if (isCurrent()) {
        row.setAttribute('aria-busy', 'false');
      }
    }
  }

  function watchDrawer() {
    observer?.disconnect();

    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    observer = new MutationObserver(records => {
      const cartChanged = records.some(record => {
        const element = record.target.nodeType === 1
          ? record.target
          : record.target.parentElement;

        // ポイント表示自身の補正では再取得しません。
        if (
          element?.closest(
            `${rowSelector}, .easy-points__cart-item-points`
          )
        ) {
          return false;
        }

        if (record.type === 'characterData') {
          return true;
        }

        return [
          ...record.addedNodes,
          ...record.removedNodes,
        ].some(node =>
          node.nodeType !== 1 ||
          !node.matches(rowSelector)
        );
      });

      if (cartChanged) {
        schedule();
      }
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    schedule();
  }

  document.addEventListener(
    'on:cart-drawer:before-open',
    schedule,
    true
  );

  document.addEventListener(
    'on:cart:after-merge',
    schedule,
    true
  );

  document.addEventListener(
    'shopify:section:load',
    watchDrawer
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      watchDrawer,
      { once: true }
    );
  } else {
    watchDrawer();
  }
})();